import React, { Component } from 'react';
import {Helmet} from "react-helmet";
import { ReactTypeformEmbed } from 'react-typeform-embed';

import './Affiliate.css';

export default class Affiliate extends Component {

    // componentDidMount() {
    //     this.renderIframeStyles();
    // }

    // renderIframeStyles() {
    //     let affiliateIframe = document.getElementsByTagName("iframe")[0];

    //     let iframeBody = affiliateIframe.contentDocument.getElementsByTagName("body")[0];
    //     return iframeBody.style.display = 'none';
    // }

    render() {
        return (
            <div className="affiliate">
                <Helmet>
                    <title>Affiliate Program - HelloAva</title>
                </Helmet>
                <div className="big-message">Join our affiliate program.</div>
                <div className="inline">
                    <div className="small-message">If you want to be on our platform so that more users can get matched to your products based on their unique skin needs, we'd love to hear from you. Please email us at partnership@helloava.co with your contact information, product selections with ingredients (csv or excel preferred). Someone from our beauty intelligence team will get in touch with you to let you know the next steps and vetting process.</div>
                </div>
                {/* <ReactTypeformEmbed style={{width: '100%', height: '600px', position: 'relative', overflow: 'hidden'}} url={'https://helloava.typeform.com/to/Y9xYTA'}/> */}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/affiliate/Affiliate.js